// extracted by mini-css-extract-plugin
export default {"sectionDivider":"_cf90fa39"};